<template>
    <div class="funding-logos">
        <span class="funding-logos-title">{{ $t("Funded by") }}</span>
        <img
            v-for="logo in logos"
            :key="logo.src"
            class="funding-logo"
            :class="{ 'funding-logo-tall': logo.tall }"
            :src="logo.src"
            :alt="logo.alt"
            loading="lazy"
        />
    </div>
</template>

<script>
// Same logos, in the same order, as the footers of the other Cibermov platforms (F-AIR 2, AIR-Core)
const FUNDING_LOGOS = [
    {
        src: "/img/funding/ue-nextgenerationeu.svg",
        alt: "Financiado por la Unión Europea - NextGenerationEU",
    },
    {
        src: "/img/funding/gobierno-de-espana.svg",
        alt: "Gobierno de España - Ministerio de Asuntos Económicos y Transformación Digital - Secretaría de Estado de Telecomunicaciones e Infraestructuras Digitales",
    },
    {
        src: "/img/funding/plan-de-recuperacion.svg",
        alt: "Plan de Recuperación, Transformación y Resiliencia",
    },
    {
        src: "/img/funding/incibe.svg",
        alt: "INCIBE - Instituto Nacional de Ciberseguridad",
    },
    {
        src: "/img/funding/icecyl-junta-castilla-y-leon.svg",
        alt: "ICECYL - Junta de Castilla y León",
    }
];

export default {
    name: "FundingLogos",
    data() {
        return {
            logos: FUNDING_LOGOS,
        };
    },
};
</script>

<style scoped>
/* Always on white, in both themes: the funders' logos must keep their official colours */
.funding-logos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px 32px;
    padding: 16px 24px;
    background-color: #fff;
    border-top: 1px solid var(--color-border);
}

/* Login and signup are full-screen modals with their own padding: stick the band to the bottom edges */
.modal-container > .funding-logos {
    flex-shrink: 0;
    margin: 1rem -0.5rem -0.5rem;
}

.funding-logos-title {
    color: #333;
    font-size: 16px;
}

.funding-logo {
    height: 40px;
    width: auto;
}

.funding-logo-tall {
    height: 56px;
}

@media (max-width: 600px) {
    .funding-logos {
        gap: 12px 20px;
        padding: 12px;
    }

    .funding-logos-title {
        width: 100%;
        text-align: center;
    }

    .funding-logo {
        height: 30px;
    }

    .funding-logo-tall {
        height: 44px;
    }
}
</style>
